import { Box, makeStyles, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { ControlState } from "../../models/flexible/control-state";
import { FlexControlProps, FlexFieldController } from "../../models/flexible/flex-field-controller";
import { StatusHistorical } from "../../models/generated/graphql";
import LyfeFormField from "../LyfeFormField";

interface FlexChatProps {
	controller: FlexFieldController;
	path: string;
	controlProps: FlexControlProps;
	state: ControlState;
}

const FlexChat = (props: FlexChatProps) => {
	const { t } = useTranslation();
	const { flexChatBox } = useStyles();
	return (
		<Box alignSelf="center" className={flexChatBox}>
			<Typography style={{ fontSize: 14 }}>{t("form-chat-info-message")}</Typography>
			<Box display="flex" flexDirection="row" marginTop={1}>
				<LyfeFormField
					id={props.controller.schema.attribute.shortLabelLocalizationKey}
					name={props.path}
					fullWidth
					multiline
					label={t(props.controller.schema.attribute.shortLabelLocalizationKey)}
					disabled={props.state === "disabled"}
					required={props.controller.schema.attribute.validation !== StatusHistorical.Optional}
					height={180}
					{...(props.controlProps as any)}
				/>
			</Box>
		</Box>
	);
};

export default FlexChat;

const useStyles = makeStyles(() => ({
	flexChatBox: {
		marginTop: "-29px",
		width: "140%",
	},
}));
